import { render, staticRenderFns } from "./case-return-query.vue?vue&type=template&id=88796b54"
import script from "./case-return-query.vue?vue&type=script&lang=ts"
export * from "./case-return-query.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports